// const VOTD_ENDPOINT = "https://developers.youversionapi.com/1.0/verse_of_the_day/1";
// const VOTD_APIKEY = "VjpLHa_WZC5McDZkM6M8sYhZth0";

// const VOTD_ENDPOINT = "http://api.houseoffirechristianchurch.com/bible";
const HOFCC_BIBLE_ENDPOINT = "http://service.houseoffirechristianchurch.com/assets/bible";
const HOFCC_API = "//api.houseoffirechristianchurch.com";
const HEROKU_API_ENDPOINT = "https://hofcc-api.azurewebsites.net"; //https://hofcc-api-service.herokuapp.com

const LIVE_PRESENTATION_ENDPOINT = "https://hofcc-live-service.azurewebsites.net/p"; //"https://hofcc-presentations-live.herokuapp.com/p";

const YOUTUBE_LINK = "https://www.youtube.com/channel/UC2nROMu3-IFADlMXiwu166g";

const FACEBOOK_LINK = "https://www.facebook.com/houseoffirechristian";
const FACEBOOK_LIVE_LINK = "https://www.facebook.com/houseoffirechristian/live";
const FACEBOOK_LIVE_LINK_TEXT = "facebook.com/houseoffirechristian/live";

export default {
    HOFCC_BIBLE_ENDPOINT: HOFCC_BIBLE_ENDPOINT,
    HEROKU_API_ENDPOINT: HEROKU_API_ENDPOINT,
    API_ENDPOINT: HOFCC_API,
    YOUTUBE_LINK: YOUTUBE_LINK,
    FACEBOOK_LINK: FACEBOOK_LINK,
    FACEBOOK_LIVE_LINK: FACEBOOK_LIVE_LINK,
    FACEBOOK_LIVE_LINK_TEXT: FACEBOOK_LIVE_LINK_TEXT,
    LIVE_PRESENTATION_ENDPOINT: LIVE_PRESENTATION_ENDPOINT
}